import Icon from '@mdi/react'
import { Font16 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const DeleteDomainFormContent = styled.div`
  ${Font16}
  line-height: 24px;
  margin: 0 auto;
  margin-top: 16px;
`
export const DeleteDomainSuccessIconWrap = styled.div`
  margin-bottom: ${theme.spacing.md};
`
export const DeleteDomainSuccessIcon = styled(Icon)`
  color: ${theme.colors.success};
`
